<template>
  <div
    :class="$style.productCard"
    @click="$handleResourceClick({ ...product, targetUrl: targetUrl })"
  >
    <!-- 商品图片 -->
    <div :class="$style.imageContainer">
      <van-image
        :src="product.commodityCoverPic"
        :class="$style.productImage"
        lazy-load
        fit="cover"
      />
    </div>

    <!-- 商品信息 -->
    <div :class="$style.productInfo">
      <!-- 商品标题 -->
      <h3 :class="$style.productTitle" :title="product.commodityTitle">
        {{ product.commodityTitle }}
      </h3>

      <!-- 价格和销量 -->
      <div :class="$style.priceSection">
        <!-- 价格 -->
        <div :class="$style.priceContainer">
          <span :class="$style.priceSymbol">¥</span>
          <span :class="$style.priceValue">
            {{ formatPrice(product.commodityPrice) }}
          </span>
        </div>

        <!-- 销量 -->
        <div :class="$style.salesInfo">
          <span :class="$style.salesLabel">销量</span>
          <span :class="$style.salesValue">
            {{ formatSales(product.saleCount) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'ProductCard',

    props: {
      // 商品数据
      product: {
        type: Object,
        required: true,
        default: () => ({
          id: '',
          title: '',
          image: '',
          price: 0,
          sales: 0,
        }),
      },
    },

    computed: {
      targetUrl() {
        const env = process.env.NODE_ENV === 'development' ? 'h5-test' : 'h5'

        return `https://h5.gogpay.cn/${env}/app/duoduo-mall/#/goods/index?isFull=true&isLogin=true&isAuth=true&id=${this.product.commodityId}`
      },
    },

    methods: {
      // 格式化价格
      formatPrice(price) {
        if (typeof price !== 'number') return '0'
        return price.toFixed(2)
      },

      // 格式化销量
      formatSales(sales) {
        if (typeof sales !== 'number') return '0'

        if (sales >= 10000) {
          return `${(sales / 10000).toFixed(1)}万`
        } else if (sales >= 1000) {
          return `${(sales / 1000).toFixed(1)}k`
        }
        return sales.toString()
      },
    },
  })
</script>

<style lang="scss" module>
  .productCard {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
  }

  .imageContainer {
    width: 100%;
    overflow: hidden;
    background-color: #f8f8f8;

    .productImage {
      display: block;
      width: 170px;
      height: 170px;
    }
  }

  .productInfo {
    padding: 12px;
    flex: 1;
    display: flex;
    flex-direction: column;

    .productTitle {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      line-height: 20px;
      margin: 0 0 8px 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .priceSection {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-top: auto;
    }
  }

  .priceContainer {
    display: flex;
    align-items: baseline;
    gap: 4px;

    .priceSymbol {
      font-size: 12px;
      color: #ff3b30;
    }

    .priceValue {
      font-size: 18px;
      color: #ff3b30;
      font-weight: 500;
    }
  }

  .salesInfo {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 12px;
    color: #999;
  }
</style>
